var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs-items',{attrs:{"value":_vm.current_item}},[_c('v-tab-item',{staticClass:"py-3",attrs:{"value":'SettingAchievements'}},[_c('achievement-setting-tab')],1),_vm._v(" "),_c('v-tab-item',{staticClass:"py-3",attrs:{"value":'ListPortfolios'}},[_c('list-portfolios')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }